"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = void 0;
/* eslint-disable */
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../../utils/tsUtils/utils");
const jwt_decode_1 = __importDefault(require("jwt-decode"));
var JSONbig = require('json-bigint')({ useNativeBigInt: true });
class UserService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    adminLogin(loginData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                const response = yield axios_1.default.post(`${this.baseUrl}user/dashboard/login`, loginData, {
                    headers: header
                });
                let decoded = (0, jwt_decode_1.default)(response.data.access_token);
                const tokenData = {
                    access_token: response.data.access_token,
                    refresh_token: response.data.refresh_token,
                    usertype: decoded.usertype
                };
                return tokenData;
            }
            catch (error) {
                throw new Error(error.response.data.message);
            }
        });
    }
    franchiseOwnerLogin(loginData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                const response = yield axios_1.default.post(`${this.baseUrl}user/dashboard/franchise/owner/login`, loginData, {
                    headers: header
                });
                let decoded = (0, jwt_decode_1.default)(response.data.access_token);
                const tokenData = {
                    access_token: response.data.access_token,
                    refresh_token: response.data.refresh_token,
                    usertype: decoded.usertype
                };
                return tokenData;
            }
            catch (error) {
                throw new Error(error.response.data.message);
            }
        });
    }
    ownerLogin(loginData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                const response = yield axios_1.default.post(`${this.baseUrl}user/dashboard/owner/login`, loginData, {
                    headers: header
                });
                let decoded = (0, jwt_decode_1.default)(response.data.access_token);
                const tokenData = {
                    access_token: response.data.access_token,
                    refresh_token: response.data.refresh_token,
                    usertype: decoded.usertype
                };
                return tokenData;
            }
            catch (error) {
                throw new Error(error.response.data.message);
            }
        });
    }
    register(registerData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)();
                const response = yield axios_1.default.post(`${this.baseUrl}user/register`, registerData, {
                    headers: header
                });
                return response.data;
            }
            catch (error) {
                throw new Error(error.response.data.message);
            }
        });
    }
    businessLogin(token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let header = (0, utils_1.getHeader)(token);
                const response = yield axios_1.default.post(`${this.baseUrl}business/login`, null, {
                    headers: header,
                    validateStatus: function (status) {
                        if (status == 404) {
                            return true;
                        }
                        return status >= 200 && status < 300;
                    }
                });
                if (response.status == 200) {
                    let decoded = (0, jwt_decode_1.default)(response.data.access_token);
                    const tokenData = {
                        isBusinessAvailable: true,
                        token: {
                            access_token: response.data.access_token,
                            refresh_token: response.data.refresh_token,
                            usertype: decoded.usertype
                        }
                    };
                    return tokenData;
                }
                else {
                    const tokenData = {
                        isBusinessAvailable: false
                    };
                    return tokenData;
                }
            }
            catch (error) {
                throw new Error('Failed to login service');
            }
        });
    }
    getUserTokenWithRefreshToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)(token);
                const response = yield axios_1.default.post(`${this.baseUrl}user/refresh`, null, {
                    headers: header
                });
                let accessToken = {
                    accessToken: response.data.access_token
                };
                return accessToken;
            }
            catch (err) {
                throw new Error('Fetching refresh token failed');
            }
        });
    }
    getTokenWithRefreshToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)(token);
                const response = yield axios_1.default.post(`${this.baseUrl}business/refresh_token`, null, {
                    headers: header
                });
                let accessToken = {
                    accessToken: response.data.access_token
                };
                return accessToken;
            }
            catch (err) {
                throw new Error('Fetching refresh token failed');
            }
        });
    }
    // eslint-disable-next-line
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                localStorage.removeItem('usertype');
                localStorage.removeItem('access_token');
                localStorage.removeItem('refresh_token');
                localStorage.clear();
                return true;
            }
            catch (error) {
                throw new Error('Failed to logout');
            }
        });
    }
    fetchUsers(fetchUsers) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/list?page=${fetchUsers.pageNumber}&limit=${fetchUsers.limit}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const respdata = response.data.data;
                return respdata;
            }
            catch (err) {
                throw new Error('Fetching users failed');
            }
        });
    }
    fetchUsersForOwner(fetchUsers) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/owner/list?page=${fetchUsers.pageNumber}&limit=${fetchUsers.limit}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const respdata = response.data.data;
                return respdata;
            }
            catch (err) {
                throw new Error('Fetching users failed');
            }
        });
    }
    fetchUsersForFranchise(fetchUsers) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/franchise/list?page=${fetchUsers.pageNumber}&limit=${fetchUsers.limit}`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return JSONbig.parse(data);
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                for (let i = 0; i < response.data.data.data.length; i++) {
                    response.data.data.data[i]['key'] = i;
                }
                const respdata = response.data.data;
                return respdata;
            }
            catch (err) {
                throw new Error('Fetching users failed');
            }
        });
    }
    fetchUserById() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/get_By_id`;
                const response = yield axios_1.default.get(url, {
                    transformResponse: [
                        (data, headers) => {
                            return data;
                        },
                        ...axios_1.default.defaults.transformResponse
                    ],
                    headers: header
                });
                const respdata = response.data.data;
                localStorage.setItem('logged_in_user', respdata.first_name);
                if (respdata.user_type === 'FOwner') {
                    localStorage.setItem('sub_business_name', respdata.outlet[0].sub_business_name);
                    localStorage.setItem('outlet_name', respdata.outlet[0].name);
                }
                return respdata;
            }
            catch (err) {
                throw new Error('Fetching users failed');
            }
        });
    }
    createUser(createUser) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/create`;
                createUser = JSONbig.stringify(createUser);
                const response = yield axios_1.default.post(url, createUser, {
                    headers: header
                });
                return response.data.message;
            }
            catch (err) {
                throw new Error('Creating user failed');
            }
        });
    }
    updateUser(createUser) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/update`;
                createUser = JSONbig.stringify(createUser);
                const response = yield axios_1.default.put(url, createUser, {
                    headers: header
                });
                return response.data.message;
            }
            catch (err) {
                throw err.response.data.message;
            }
        });
    }
    updateProfile(createUser) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/edit`;
                createUser = JSONbig.stringify(createUser);
                const response = yield axios_1.default.put(url, createUser, {
                    headers: header
                });
                return response.data.message;
            }
            catch (err) {
                throw new Error('Updating user failed');
            }
        });
    }
    resetPassword(resetPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/editpassword`;
                resetPassword = JSONbig.stringify(resetPassword);
                const response = yield axios_1.default.put(url, resetPassword, {
                    headers: header
                });
                return response.data.message;
            }
            catch (err) {
                throw new Error('Resetting password failed');
            }
        });
    }
    sendOtp(sendOtp) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/owner/sendotp`;
                sendOtp = JSONbig.stringify(sendOtp);
                const response = yield axios_1.default.post(url, sendOtp, {
                    headers: header
                });
                return response.data.message;
            }
            catch (err) {
                throw new Error('Sending OTP failed');
            }
        });
    }
    sendAdminOtp(sendOtp) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/sendotp`;
                sendOtp = JSONbig.stringify(sendOtp);
                const response = yield axios_1.default.post(url, sendOtp, {
                    headers: header
                });
                return response.data.message;
            }
            catch (err) {
                throw new Error('Sending OTP failed');
            }
        });
    }
    verifyOtp(sendOtp) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/owner/verifyotp`;
                sendOtp = JSONbig.stringify(sendOtp);
                const response = yield axios_1.default.post(url, sendOtp, {
                    headers: header
                });
                return response.data.message;
            }
            catch (err) {
                throw new Error('Verifying OTP failed');
            }
        });
    }
    verifyAdminOtp(sendOtp) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const header = (0, utils_1.getHeader)();
                let url = `${this.baseUrl}user/verifyotp`;
                sendOtp = JSONbig.stringify(sendOtp);
                const response = yield axios_1.default.post(url, sendOtp, {
                    headers: header
                });
                return response.data.message;
            }
            catch (err) {
                throw new Error('Verifying OTP failed');
            }
        });
    }
}
exports.UserService = UserService;
